module.exports = __webpack_public_path__ + "img/logo.22555a8e.png";